// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__ipUje","tab":"Tabs_tab__17j60","tabActive":"Tabs_tabActive__2epEW"};